export enum ContractedPowerNames {
  Subscribed = 'Abonnerad effekt',
  Charged = 'Debiterbar effekt',
  Annual = 'Årseffekt',
  SubscribedMax = 'Abonnerad maxeffekt',
  Recommended = 'Rekommenderad effekt',
  RevisedRecommended = 'Reviderad rekommenderad effekt',
  RecommendedMax = 'Rekommenderad maxeffekt',
  RevisedRecommendedMax = 'Reviderad rekommenderad maxeffekt',
  RecommendedBase = 'Rekommenderad baseffekt',
  CustomerSelected = 'Kundvald effekt'
  // OldSubscribed = 'Abonnerad effekt' // Should not be used, when new terminology is implemented in PROD
}

export enum ContractedPowerSorts {
  Debitable = 'Debiterbar effekt',
  DebitableMax = 'Debiterbar maxeffekt',
  Withdrawed = 'Uttagen timeffekt',
  Base25 = "Baseffekt 25",
  Max25 = "Maxeffekt 25"
}

export enum ContractedPowerTypes {
  Real = 'Verklig',
  Recommended = 'Rekommenderad',
  Affix = "Ansatt"
}
